<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <div id="app">
      <Header v-if="!isMobile()" />
      <!--<HeaderMobile v-else />-->
      <v-slide-x-transition mode="out-in">
        <router-view />
      </v-slide-x-transition>

      <v-footer
        :style="{ background: $vuetify.theme.themes[theme].background }"
        padless
        absolute
        app
      >
        <v-col class="text-center" cols="12">
          {{ $vuetify.lang.t("$vuetify.footer") }}
          - SUTTER Julien @{{ new Date().getFullYear() }}
        </v-col>
      </v-footer>
    </div>
  </v-app>
</template>

<script>
import Header from "@/components/header/Header.vue";

export default {
  name: "App",
  components: {
    /*Header,
    HeaderMobile*/
    Header
  },

  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Epilogue&display=swap");
#app {
  font-family: "Epilogue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.v-application .text-h5 {
  font-family: "Epilogue", sans-serif !important;
}
.blockquote {
  width: 95%;
  margin: auto;
}
</style>
